import "jquery";
import "jquery-validation";
import "jquery-validation-unobtrusive";
import "bootstrap-sass";
import "jquery-ui/ui/widget.js";
import "jquery-ui/ui/keycode.js";
import "jquery-ui/ui/widgets/mouse.js";
import "jquery-ui/ui/widgets/slider.js";
import "../plugins/jquery.mousewheel.min.js";
import "../plugins/parsley-1.1.9.min.js";
import "../plugins/jquery.placeholder.min.js";
import "../plugins/flexslider.modified.min.js";
import "../plugins/chosen.jquery.js";
import "../plugins/canvasloader.js";
import "../plugins/jquery.scrollTo.min.js";
import "../plugins/jquery.joyride-2.0.3.js";
import "../plugins/jquery.ganttview.modified.js";
import "../plugins/datejs-1.0-alpha-1.min.js";
import "../plugins/jquery.cookie.js";
import "../../vendors/js-cookie/js/js.cookie.js";
import"../plugins/folkspel-tracker-helper.js";
import "../widgethandler.js";
import "../functions_folkspel.js";
import "../search";

var common = require.context("../widgets/common/", true, /\.js$/);
common.keys().forEach(common);

var modules = require.context("../modules/", true, /\.js$/);
modules.keys().forEach(modules);

var modulesadmin = require.context("../modules/admin", true, /\.js$/);
modulesadmin.keys().forEach(modulesadmin);